"use strict";

// eslint-disable-next-line no-empty-function
module.exports = function () {};



//////////////////
// WEBPACK FOOTER
// ./node_modules/es5-ext/function/noop.js
// module id = 319
// module chunks = 0